export default function Media(module: ContentfulMedia): SiteMedia {
    return {
        cms_id: module.sys.id,
        cms_type: module.sys.contentType.sys.id,
        fields: {
            name: module.fields.name,
            media: module.fields.media,
        },
    };
}

export async function parseMediaImageTile(module: ContentfulMedia): Promise<SiteEntityImageTile> {
    const media = Media(module);
    return {
        cms_id: media.cms_id,
        cms_type: 'EntityImageTile',
        fields: {
            name: media.fields.name,
            image: media.fields.media,
        },
    };
}